export class HttpRequestError extends Error {
  readonly code?: string;
  readonly participantIndex?: number;

  constructor(message: string, details?: object) {
    super(message);
    this.name = "HttpRequestError";
    const value = details as { code?: unknown; participantIndex?: unknown } | undefined;
    if (typeof value?.code === "string") this.code = value.code;
    if (typeof value?.participantIndex === "number" && Number.isSafeInteger(value.participantIndex) && value.participantIndex >= 0) {
      this.participantIndex = value.participantIndex;
    }
  }
}

export const visitorReviewMessage = "Vérifiez les informations saisies pour ce visiteur en cliquant sur Modifier. Si elles sont correctes ou si le blocage persiste, contactez un gestionnaire habilité. Votre brouillon est conservé.";

export function getBlockedVisitor<T>(error: unknown, submitted: readonly T[]): T | undefined {
  if (!(error instanceof HttpRequestError) || !isVisitorCreationIdentityError(error) || error.participantIndex === undefined) return undefined;
  return submitted[error.participantIndex];
}

function isVisitorCreationIdentityError(error: HttpRequestError) {
  return ["VISITOR_IDENTITY_REVIEW_REQUIRED", "VISITOR_NPI_CONFLICT", "VISITOR_NPI_UNAVAILABLE"].includes(error.code ?? "");
}

export function getVisitorCreationErrorMessage(error: unknown): string {
  if (error instanceof HttpRequestError && (error.code === "VISITOR_NPI_CONFLICT" || error.code === "VISITOR_NPI_UNAVAILABLE")) {
    return `${error.message} Votre brouillon est conservé.`;
  }
  return visitorReviewMessage;
}
